import type {
  DlpOrderFormModel,
  SecondaryMarketDlpOrderField,
  SecondaryMarketDlpOrderTabContent,
} from './dlpOrderForm.model';

export type SecondaryMarketDlpOrderFormActions =
  | SecondaryMarketDlpOrderTabContentPersistRequested
  | SecondaryMarketDlpOrderTabContentPersisted
  | SecondaryMarketDlpOrderFormFieldChanged;

/////////////////////////////////////////////

export function secondaryMarketDlpOrderTabContentPersistRequested(
  tabId: string,
  tabContent: SecondaryMarketDlpOrderTabContent,
) {
  return {
    type: 'SECONDARY_MARKET_DLP_ORDER_TAB_CONTENT_PERSIST_REQUESTED' as const,
    tabId,
    tabContent,
  };
}
export type SecondaryMarketDlpOrderTabContentPersistRequested = ReturnType<
  typeof secondaryMarketDlpOrderTabContentPersistRequested
>;

/////////////////////////////////////////////

export function secondaryMarketDlpOrderTabContentPersisted(
  tabId: string,
  tabContent: SecondaryMarketDlpOrderTabContent,
) {
  return {
    type: 'SECONDARY_MARKET_DLP_ORDER_TAB_CONTENT_PERSISTED' as const,
    tabId,
    tabContent,
  };
}

export type SecondaryMarketDlpOrderTabContentPersisted = ReturnType<typeof secondaryMarketDlpOrderTabContentPersisted>;

export function secondaryMarketDlpOrderFormFieldChanged<F extends SecondaryMarketDlpOrderField>(
  tabId: string,
  field: F,
  value: DlpOrderFormModel[F],
) {
  return {
    type: 'SECONDARY_MARKET_DLP_ORDER_FORM_FIELD_CHANGED' as const,
    tabId,
    field,
    value,
  };
}
export type SecondaryMarketDlpOrderFormFieldChanged = ReturnType<typeof secondaryMarketDlpOrderFormFieldChanged>;
